import { defineRouting } from "next-intl/routing";

/**
 * Язык живёт в URL (KAN-1188): /ru/..., /en/... — у каждой страницы свой адрес
 * на каждом языке, и её можно отдать статикой. Путь без префикса middleware
 * перенаправляет по cookie `locale` (прежнее хранилище выбора языка), затем по
 * Accept-Language, иначе на ru.
 */
export const routing = defineRouting({
  locales: ["ru", "en"],
  defaultLocale: "ru",
  localePrefix: "always",
  localeCookie: { name: "locale", maxAge: 60 * 60 * 24 * 365 },
});

export type AppLocale = (typeof routing.locales)[number];

/** Путь без префикса языка: "/ru/banned" → "/banned", "/en" → "/". */
export function stripLocale(pathname: string): string {
  return pathname.replace(/^\/(ru|en)(?=\/|$)/, "") || "/";
}
